import { loader } from 'graphql.macro'

export default function resourceType ({ dataLoaders, queryKey }) {
  const [, haulerId, id] = queryKey
  const schema = loader('./resourceType.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    haulerId, id
  })
}
